export default __webpack_public_path__ + "static/media/success_with_us.4d387928.png";